import * as Styled from './styled'
import { Text } from 'common-components'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IAIVideoProject, IAIVideoModel } from 'types/aiVideo'
import { getModelDisplayName } from '../utils'
import { getStringifiedQuality } from 'store/features/aiVideo/utils'
import CopyIcon from 'assets/svgr-icons/Copy.svg'
import Tooltip from 'components/Tooltip'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

interface IVideoDetailsContentProps {
  item: IAIVideoProject
  aiVideoModels: IAIVideoModel[]
}

const VideoDetailsContent = ({
  item,
  aiVideoModels
}: IVideoDetailsContentProps) => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  const MAX_PROMPT_DISPLAY_LENGTH = isMobile ? 150 : 440
  const TRUNCATED_SLICE_LENGTH = isMobile ? 150 : 460

  const displayPrompt =
    item.prompt.length > MAX_PROMPT_DISPLAY_LENGTH
      ? `${item.prompt.slice(0, TRUNCATED_SLICE_LENGTH)}...`
      : item.prompt

  const handleCopyPrompt = () => {
    navigator.clipboard.writeText(item.prompt)
  }

  return (
    <Styled.Content>
      {item.prompt?.length > 0 ? (
        <>
          <Styled.PromptHeader>
            <Text color="secondary" type="h4">
              {translate(T.PROMPT)}
            </Text>
            <Tooltip tooltipText={translate(T.COPY_PROMPT_TOOLTIP)}>
              <Styled.CopyButton onClick={handleCopyPrompt}>
                <CopyIcon />
              </Styled.CopyButton>
            </Tooltip>
          </Styled.PromptHeader>
          <Styled.PromptText type="h2" color="secondaryDark">
            {displayPrompt}
          </Styled.PromptText>
        </>
      ) : null}
      <Styled.ModelAndQuality>
        <Styled.MetaChip>
          <Text color="secondaryDark" type="h4">
            {getModelDisplayName(item.videoModel, aiVideoModels)}
          </Text>
        </Styled.MetaChip>
        <Styled.MetaChip>
          <Text color="secondaryDark" type="h4">
            {getStringifiedQuality(item.quality)}
          </Text>
        </Styled.MetaChip>
      </Styled.ModelAndQuality>
      {(item.referenceMedias?.images?.length ?? 0) > 0 ? (
        <Styled.ReferenceImages>
          <Text color="secondary" type="h4">
            {translate(T.REFERENCE_IMAGES_LABEL)}
          </Text>
          <Styled.RefImages>
            {item.referenceMedias.images!.map(image => (
              <Styled.RefImage
                key={image.url}
                src={image.url}
                alt={image.type}
                loading="lazy"
              />
            ))}
          </Styled.RefImages>
        </Styled.ReferenceImages>
      ) : null}
    </Styled.Content>
  )
}

export default VideoDetailsContent
